import React, { Component } from "react";
import { Form, InputGroup, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt} from "@fortawesome/free-solid-svg-icons";
import "../../assets/css/attrib-cards.css";
import { toCardId, toCardTitle, removeArrayValue } from "./AttribCardUtils.js";
import CreatableSelect from "react-select/creatable";
import AppConfig from "../AppConfig/AppConfig.js";
import AuthService from "../AuthService/AuthService.js";
import GlasschainHttpClient from "../ApiService/GlasschainHttpClient.js";

// const components = {
//   // DropdownIndicator: null,
// };

const createOption = (label) => ({
    label,
    value: label,
});

const components = {
    DropdownIndicator: null
};


export default class AttribApiMultipleLookupMapCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardState: "untouched",
            enabled: false,
            valid: true,
            inputValue: "",
            value: [],
            descript: "",
            lookupButtonEnabled: false,
            inLookup: false,
            lookupError: false,
            lookupErrMsg: ""
        };

        this.appConfig = new AppConfig();
        this.auth = new AuthService();
        this.apiClient = new GlasschainHttpClient();
        this.gcid = this.auth.getGcid();

        this.Id = toCardId(this.props.attribTitle);
        this.tags = this.props.attribTags ? this.props.attribTags : [""];

        this.renderState = this.renderState.bind(this);
        this.renderUntouchedState = this.renderUntouchedState.bind(this);
        this.renderActiveState = this.renderActiveState.bind(this);
        this.onCardClick = this.onCardClick.bind(this);
        this.onLoseFocus = this.onLoseFocus.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onTagToggle = this.onTagToggle.bind(this);
        this.toTagId = this.toTagId.bind(this);
        this.onValidityCheck = this.onValidityCheck.bind(this);
        this.onLookupButtonClick = this.onLookupButtonClick.bind(this);
        this.mapEntityFields = this.mapEntityFields.bind(this);
    }

    onValidityCheck(isOn, tagsOn) {
        if ((this.props.validation) && (this.props.validation.requiresSubcheck)) {
            var isValid = (((isOn) && (tagsOn.length > 0)) || (!isOn));
            if (isValid !== this.state.valid) {
                // validity state has changed!
                this.setState({ valid: isValid });
                this.props.onValidationChange(this.Id, isValid, this.props.validation.requiredMessage);
            }
        }
    }

    toTagId() {
        return this.Id;
    }

    // toggle the entire pre-inspect reject
    onToggle(ev) {
        console.log(ev.target.checked);
        let isOn = ev.target.checked;
        let newTagsOn = this.state.value;
        if (!isOn) {
            newTagsOn.map((tag) => this.props.onValueRemove(this.toTagId(tag.value)));
            newTagsOn = []; // clear all tags
        }
        this.onValidityCheck(isOn, newTagsOn);
        this.setState({
            enabled: isOn,
            value: newTagsOn,
        });
        this.props.onValueChange(this.Id, ev.target.checked);
    }

    onTagToggle(ev) {
        console.log(ev.target.name + " " + ev.target.checked);
        var newTagsOn = this.state.tagsOn;
        if (ev.target.checked) {
            newTagsOn.push(ev.target.name);
            this.props.onValueChange(this.toTagId(ev.target.name), true);
        }
        else {
            newTagsOn = removeArrayValue(newTagsOn, ev.target.name);
            this.props.onValueRemove(this.toTagId(ev.target.name));
        }
        this.onValidityCheck(this.state.enabled, newTagsOn);
        this.setState({ tagsOn: newTagsOn });

    }

    onLoseFocus() {
        var newCardState = this.state.enabled ? "touched" : "untouched";
        if (this.state.value !== [] && this.state.value !== null) {
            newCardState = "touched"
        }
        this.setState({ cardState: newCardState });
    }

    onCardClick(ev) {
        var newState = "untouched";
        if (this.state.cardState === "active") {
            newState = this.state.enabled ? "touched" : "untouched";
            if (this.state.value !== [] && this.state.value !== null) {
                newState = "touched"
            }
        } else {
            newState = "active";
        }
        this.setState({ cardState: newState });
        this.props.onToggleCard(this);
    }

    renderUntouchedState() {
        return (
            <div className="nonactivecard card-template shadow6" onClick={this.onCardClick}>
                {this.props.attribTitle}
            </div>
        );
    }

    handleChange = (value, actionMeta) => {
        if (actionMeta.action === "remove-value") {
            let tagValue = actionMeta.removedValue.value;
            this.props.onValueRemove(this.toTagId(tagValue));
        }

        /*
        this.onValidityCheck(this.state.enabled, value);
        this.setState({ value });
        if (value && value.length > 0) {
            this.props.onValueChange(this.toTagId(value[value.length - 1].value), true);
        };
        */
       var returnValue = [];
       if (value)
       {
            returnValue = value.map(v => {
                return v.value;
            });
        }   
        this.props.onValueChange(this.toTagId(), returnValue);
        this.onValidityCheck(this.state.enabled, returnValue);
        this.setState({ value });

    };

    handleInputChange = (inputValue) => {
        this.setState({ inputValue });
    };


    handleKeyDown = (event) => {
        const { inputValue, value } = this.state;
        if (!inputValue) return;
        if (!value){
            this.setState({
                value: []
            })
        };

        switch (event.key) {
            case "Enter":
            case "Tab":
                this.setState({
                    inputValue: "",
                    value: [...value, createOption(inputValue)],
                    lookupButtonEnabled: true
                });
                event.preventDefault();
                // convert to an array of just the values
                var returnValue = value.map(v => {
                    return v.value;
                });
                returnValue.push(inputValue);
                this.props.onValueChange(this.toTagId(), returnValue);
                this.onValidityCheck(this.state.enabled, [...value, createOption(inputValue)]);
                break;
            default:
                break;
        }
    };

    async onLookupButtonClick() {
        console.log("lookup button clicked!")
        // only works if we have a value to look up!
        if (!this.state.value || this.state.value === []) return;
        var val = this.state.value[0].label;
        // confirm they have access to this adapter and role
        if (!this.appConfig.hasAdapterProxyRole(this.gcid, this.props.proxyClientRole)) {
          this.setState({ palletTagButtonEnabled: false });
          return;
        }
        this.setState({inLookup: true});
        let hasEntityResult = await this.apiClient.hasProxyEntity(
          this.gcid,
          this.props.entityExistsApiUrl,
          val
        );
        console.log("has entity? " + hasEntityResult);
        if (!hasEntityResult) {
          this.setState({ 
            lookupErrMsg: "Unable to locate " + val,
            lookupError: true,
            inLookup: false,
            lookupButtonEnabled: true
           });
        } else {
          var entityResult = await this.apiClient.fetchProxyEntity(
            this.gcid,
            this.props.entityLookupApiUrl,
            val
          );
          var entity = entityResult;
          // now map entity values to onValueChange for each mapped field
          this.mapEntityFields(entity);
          this.setState({
            lookupErrMsg: "",
            lookupError: false,
            lookupButtonEnabled: true,
            inLookup: false
          });
        }
      }


      isRepressedOverwrite(key, valueBag, repressedOverwrites)
      {
        if (!repressedOverwrites) return false;
        var hasKey = repressedOverwrites.includes(key);
        if (!hasKey) return false;
        var keyIsInValueBag = (key in valueBag);
        if (!keyIsInValueBag) return false;
        if ((valueBag[key].trim() === "") || (valueBag[key] == null)) return false;
        return true;
      }


      mapEntityFields(entity) {
        console.log("returned entity: ");
        console.log(entity);
        for (var key in this.props.fieldMap) {
          let entityField = this.props.fieldMap[key];
          var val = Object.byString(entity, entityField);
          console.log("attempting to get val for key " + key + " from entity field " + entityField);
          if (val) {
    
            if (!this.isRepressedOverwrite(key, this.props.valueBag, this.props.repressedOverwrites))
            {
              console.log("attempting to update " + key + " with " + val);
              this.props.onValueChange(key, val);
            }
          }
        }
      }
    

    renderActiveState() {
        const { inputValue, value } = this.state;
        const formattedOptions = this.props.attribTags.map((opt) => {
            return createOption(opt);
        })

        return (
            <div
                className="activecard shadow6 card-template multipallet-input"
            >
                <div onClick={this.onCardClick}>
                    {this.props.attribTitle}
                </div>

                <div>
                    <InputGroup >

                        <CreatableSelect
                            components={components}
                            className="multipallet-dropdown"
                            inputValue={inputValue}
                            // options={formattedOptions}
                            isClearable
                            isMulti
                            menuIsOpen={false}
                            isDisabled={false}
                            onChange={this.handleChange}
                            onInputChange={this.handleInputChange}
                            onKeyDown={this.handleKeyDown}
                            placeholder="Type Tag and Press Enter"
                            value={value}
                        />
                        <Button className="multipallet-button"
                            disabled={!this.state.lookupButtonEnabled}
                            onClick={this.onLookupButtonClick}
                            fontColor={(this.state.lookupError) ? "yellow" : "white"}
                        >
                            {(this.state.inLookup) ? <FontAwesomeIcon icon={faSyncAlt} color="lightgreen" spin={true} /> : <span />}
                            &nbsp;Lookup
                        </Button>
                        <div align="center" style={{ fontColor: "yellow" }}>
                            {this.state.lookupErrMsg}
                        </div>
                    </InputGroup>
                </div>
            </div>
        );
    }

    renderTouchedState() {

        if (!this.state.value || this.state.value.length === 0 || this.state.value === null) {
            this.setState({
                value: ["none"]
            })
        }
        return (
            <div
                className="nonactivecard"
                onClick={this.onCardClick}
                style={{ backgroundColor: "lightgreen" }}
            >
                <div style={{ fontSize: "20px" }}>
                    {this.props.attribTitle.toUpperCase()}
                </div>


                {this.state.value.map((tag, index) => (
                    <div
                        style={{
                            textAlign: "center",
                            fontSize: "20px",
                            fontColor: "purple",
                        }}
                    >
                        {tag.label}
                    </div>
                ))}


            </div>
        );
    }

    renderState() {
        switch (this.state.cardState) {
            case "untouched":
                return this.renderUntouchedState();
            case "touched":
                return this.renderTouchedState();
            default:
                return this.renderActiveState();
        }
    }

    render() {
        return this.renderState();
    }
}
